export default class Animation {
    constructor(ele, options) {
        this.options = $.extend({}, {name: 'animate', onComplete: null}, options);
        this.$element = ele;
        this._tl = new TimelineMax({onComplete:this._onComplete.bind(this), paused: true});
        this.addTimeline();
    }

    addTimeline() {}

    play() {
        this.$element.css('opacity', 1);
        this._tl.play();
    }

    reverse(speed=0) {
        this._tl.reverse(speed);
    }

    getElement(selector, hidden=true) {
        return this.$element.find(selector).css('opacity', hidden ? 0 : 1);
    }

    _onComplete() {
        // console.log('onComplete');
        if($.isFunction(this.options.onComplete)) {
            this.options.onComplete.call();
        }
    }
}